import type { SVGProps } from 'react';

import CrossNaked from './Cross-Naked.svg';

export const CrossNakedIcon = (props: SVGProps<SVGSVGElement>) => <CrossNaked {...props} />;
